export default {"src":"/_next/static/media/icon_youtube1.661efd48.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};